import { regionOptions, yearOptions, sortOptions } from "@/mocks/videos";

export interface CategoryFilters {
  region: string;
  year: string;
  sort: string;
}

interface FilterPanelProps {
  filters: CategoryFilters;
  onChange: (next: Partial<CategoryFilters>) => void;
  onReset: () => void;
}

function FilterGroup({
  title,
  options,
  value,
  onSelect,
}: {
  title: string;
  options: { key: string; label: string }[];
  value: string;
  onSelect: (key: string) => void;
}) {
  return (
    <div className="mb-6 last:mb-0">
      <h3 className="text-sm font-semibold text-foreground-900 mb-3">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt.key}
            type="button"
            onClick={() => onSelect(opt.key)}
            className={`px-3 py-1.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
              value === opt.key
                ? "bg-primary-600 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({
  filters,
  onChange,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-base font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-600"></i>
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="text-sm text-secondary-700 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          重置
        </button>
      </div>

      <FilterGroup
        title="地区"
        options={regionOptions.map((r) => ({ key: r, label: r }))}
        value={filters.region}
        onSelect={(key) => onChange({ region: key })}
      />
      <FilterGroup
        title="年份"
        options={yearOptions.map((y) => ({ key: y, label: y }))}
        value={filters.year}
        onSelect={(key) => onChange({ year: key })}
      />
      <FilterGroup
        title="排序方式"
        options={sortOptions.map((s) => ({ key: s.key, label: s.label }))}
        value={filters.sort}
        onSelect={(key) => onChange({ sort: key })}
      />
    </div>
  );
}